import script from "./ReportsSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsSidebar.vue?vue&type=style&index=0&id=5e08b62e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e08b62e"]])

export default __exports__